import { Card } from '../components/ui/card';
import { CalendarIcon, ClockIcon } from '../components/ui/icons';

const UserAvatar = ({ size = 'md', name = '익명' }: { size?: 'sm' | 'md' | 'lg' | 'xl'; name?: string }) => {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-7 h-7 text-xs',
    lg: 'w-8 h-8 text-sm',
    xl: 'w-24 h-24 text-3xl',
  };

  // 이름 기반으로 색상 생성 (단색)
  const getAvatarColor = (aname: string) => {
    const colors = [
      'bg-slate-500',
      'bg-gray-500',
      'bg-zinc-500',
      'bg-neutral-500',
      'bg-stone-500',
      'bg-red-500',
      'bg-blue-500',
      'bg-green-500',
    ];
    const index = aname.charCodeAt(0) % colors.length;
    return colors[index];
  };
  return (
    <div
      className={`${sizeClasses[size]} ${getAvatarColor(name)} rounded-full flex items-center justify-center text-white font-medium flex-shrink-0`}>
      {name.charAt(0).toUpperCase()}
    </div>
  );
};

/**
 *
 * @author hjkim
 * @constructor
 */
const UserInfoPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1">
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30">
          <div className="max-w-4xl mx-auto px-4 py-8">
            {/* 프로필 헤더 */}
            <Card className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
              <div className="flex items-center gap-6">
                <UserAvatar size="xl" />
                <div className="flex-1">
                  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Name</h1>
                  <p className="text-gray-600 mb-2">Name2</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-1">
                      <CalendarIcon className="w-4 h-4" />
                      <span>에 가입</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <ClockIcon className="w-4 h-4" />
                      <span>활동 4일째</span>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfoPage;
